import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
}

/* The small uppercase label with a rule that sits above section headings. */
export const Eyebrow: FC<EyebrowProps> = ({ children, className }): ReactNode => {
    return (
        <p className={cn('inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.24em] text-primary', className)}>
            <span aria-hidden='true' className='h-px w-8 bg-current opacity-60' />
            {children}
        </p>
    )
}
